(function(){
 async function clearLegacyPickup(){
  try {
   const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
   const cart=await fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw Error('Cart read failed');return r.json()});
   const a=cart.attributes||{};
   if(a['Pickup Window']||a['Pickup Hours Rule']){
    const r=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:{'Pickup Window':'','Pickup Hours Rule':''}})});
    if(!r.ok)throw Error('Legacy pickup cleanup failed');
   }
  }catch(e){console.warn('THC pickup cleanup:',e.message)}
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',clearLegacyPickup);else clearLegacyPickup();
})();